import getBatchValues from 'src/js/modules/element-settings/helpers/get-batch-values';
import generateModifiedEventTraits from 'src/js/modules/element-settings/helpers/generate-modified-event-traits';
import appearanceAttributes from '../constants/appearance-attributes';

const getTraitName = (attribute) => {
  switch (attribute) {
    case appearanceAttributes.BORDER_TOP_LEFT_RADIUS: {
      return 'TopLeftCorner';
    }

    case appearanceAttributes.BORDER_TOP_RIGHT_RADIUS: {
      return 'TopRightCorner';
    }

    case appearanceAttributes.BORDER_BOTTOM_LEFT_RADIUS: {
      return 'BottomLeftCorner';
    }

    case appearanceAttributes.BORDER_BOTTOM_RIGHT_RADIUS: {
      return 'BottomRightCorner';
    }

    default: {
      return attribute;
    }
  }
};

const getMediaAppearanceModifiedTraits = ({ prefix, modifiedAttributes, state, initialState }) => {
  const elementIds = Object.keys(initialState);

  const modifiedTraits = modifiedAttributes.reduce((accTraits, attribute) => {
    const [currentValue] = getBatchValues(state, {
      elementIds,
      attributes: [attribute],
    }).flat();
    const [initialValue] = getBatchValues(initialState, {
      elementIds,
      attributes: [attribute],
    }).flat();

    if (typeof currentValue === 'boolean') {
      return accTraits;
    }

    const currentTraitName = getTraitName(attribute);
    const currentTraits = generateModifiedEventTraits(
      prefix,
      currentTraitName,
      initialValue,
      currentValue
    );

    return {
      ...accTraits,
      ...currentTraits,
    };
  }, {});

  return modifiedTraits;
};

export default getMediaAppearanceModifiedTraits;
